import Div from '@jumbo/shared/Div'
import { Button, Dialog, DialogActions, DialogContent, IconButton, Paper, Typography, styled, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { MdCheck, MdClear, MdClose, MdDelete } from 'react-icons/md'
import { TiCancel } from 'react-icons/ti'
import { ErpCancelButton, ErpSaveUpdateButton } from './ButtonComponent'
import Draggable from 'react-draggable'
import PropTypes from 'prop-types'


const DialogBox = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: 5,
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.divider}`,
    },
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.error.main,
    '&:hover': {
        backgroundColor: theme.palette.error.light,
        color: theme.palette.background.default,
    },
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(0.5),
    textAlign: 'left',
    // backgroundColor: theme.palette.error.light,
    // color: theme.palette.error.contrastText,
    borderRadius: theme.shape.borderRadius,
}));


export function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}


export const ErpDeleteDialogBox = ({ flag, setFlag, handleClick, content, id, isMobile }) => {
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <DialogBox open={flag}
            maxWidth={window.innerWidth <= 600 ? 'xs' : window.innerWidth <= 768 ? 'sm' : window.innerWidth <= 992 ? 'sm' : 'sm'}
            fullWidth
            onClose={() => setFlag(false)}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogContent id="draggable-dialog-title">
                <Typography variant="h4">
                    {content}
                    <span>&nbsp;</span>
                    <span style={{ fontWeight: 500 }}>
                        "{id}" ?
                    </span>
                </Typography>
            </DialogContent>
            <DialogActions>
                {isMobile ? isMobile : isMdUp ? (
                    <>
                        <Button variant="contained" color={"error"} endIcon={<MdDelete />} onClick={handleClick}>
                            Delete
                        </Button>
                        <Button variant="contained" endIcon={<TiCancel />} onClick={() => setFlag(false)}>
                            Cancel
                        </Button>
                    </>
                ) :
                    <Div className="buttons" sx={{ display: "flex" }}>
                        <ErpSaveUpdateButton onClick={handleClick} name={"Delete"} type={"button"} icon={<MdDelete size={18} />} />
                        <ErpCancelButton onClick={() => setFlag(false)} icon={<TiCancel size={22} />} />
                    </Div>
                }
            </DialogActions>
        </DialogBox>
    )
}


export const ErpConfirmDialogBox = ({ flag, setFlag, handleClick, content, isMobile }) => {
    return (
        <Dialog
            open={flag}
            maxWidth="sm"
            fullWidth
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogContent id="draggable-dialog-title">
                <Typography variant='h5'>
                    {content}
                </Typography>
                <br />
                <Typography variant='h5'>
                    Do you want still to continue...
                </Typography>
            </DialogContent>
            <DialogActions>
                {isMobile ? (
                    <>
                        <Button variant="contained" color={"error"} endIcon={<MdCheck />} onClick={() => setFlag(false)} >
                            Yes
                        </Button>
                        <Button variant="contained" endIcon={<MdClear />} onClick={handleClick}>
                            No
                        </Button>
                    </>
                ) :
                    <Div className="buttons" sx={{ display: "flex" }}>
                        <ErpSaveUpdateButton onClick={() => setFlag(false)} name={"Yes"} type={"button"} icon={<MdCheck size={16} />} />
                        <ErpCancelButton name={"No"} onClick={handleClick} icon={<MdClear size={16} />} />
                    </Div>
                }
            </DialogActions>
        </Dialog>
    )
}


export const ErpStatusConfirmDialogBox = ({ flag, setFlag, handleClick, content, isMobile, sx }) => {
    return (
        <Dialog
            open={flag}
            maxWidth="sm"
            fullWidth
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            sx={sx}
        >
            <DialogContent id="draggable-dialog-title">
                <Typography variant='h4'>
                    {content}
                </Typography>
            </DialogContent>
            <DialogActions>
                {isMobile ? (
                    <>
                        <Button variant="contained" color={"error"} endIcon={<MdCheck />} onClick={handleClick} >
                            Yes
                        </Button>
                        <Button variant="contained" endIcon={<MdClear />} onClick={() => setFlag(false)} >
                            No
                        </Button>
                    </>
                ) :
                    <Div className="buttons" sx={{ display: "flex" }}>
                        <ErpSaveUpdateButton onClick={handleClick} name={"Yes"} type={"button"} icon={<MdCheck size={16} />} />
                        <ErpCancelButton name={"No"} onClick={() => setFlag(false)} icon={<MdClear size={16} />} />
                    </Div>
                }
            </DialogActions>
        </Dialog>
    )
}


export const ErpAlertViewDialogBox = ({ flag, setFlag, isMobile }) => {
    return (
        <DialogBox
            open={flag}
            maxWidth="xs"
        >
            <DialogContent>
                <Div sx={{ p: 0, m: 0, mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <CustomTypography variant='h4'>
                        Alert
                    </CustomTypography>

                    <StyledIconButton onClick={() => setFlag(false)} sx={{ p: 0.1 }}>
                        <MdClose size={22} />
                    </StyledIconButton>
                </Div>
                <Typography variant='h5' sx={{ color: 'text.secondary' }}>
                    You don't have the permission to view this page.
                </Typography>
            </DialogContent>
        </DialogBox>
    )
}


ErpDeleteDialogBox.propTypes = {
    flag: PropTypes.bool,
    setFlag: PropTypes.bool,
    handleClick: PropTypes.func,
    content: PropTypes.string,
    id: PropTypes.string,
    isMobile: PropTypes.string,
};

ErpConfirmDialogBox.propTypes = {
    flag: PropTypes.bool,
    setFlag: PropTypes.bool,
    handleClick: PropTypes.func,
    content: PropTypes.string,
    isMobile: PropTypes.string,
};


ErpStatusConfirmDialogBox.propTypes = {
    flag: PropTypes.bool,
    setFlag: PropTypes.bool,
    handleClick: PropTypes.func,
    content: PropTypes.string,
    id: PropTypes.string,
    isMobile: PropTypes.string,
    sx: PropTypes.string,
};

ErpAlertViewDialogBox.propTypes = {
    flag: PropTypes.bool,
    setFlag: PropTypes.bool,
    isMobile: PropTypes.string,
};


